import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import Chatbot from './pages/Chatbot';
import ProtectedRoute from './components/ProtectedRoute';
import UpgradePage from './pages/UpgradePage'; // 1. Import the new UpgradePage
import PaymentPage from './pages/PaymentPage'; // <-- Import the new page
import DreamFeaturePage from './pages/DreamFeaturePage'; // <-- Import the dream page

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/payment" element={<PaymentPage />} /> {}
        <Route
          path="/mentorai"
          element={
            <ProtectedRoute>
              <Chatbot />
            </ProtectedRoute>
          }
        />
        {/* 2. Add the new protected route for the upgrade page */}
        <Route
          path="/upgrade"
          element={
            <ProtectedRoute>
              <UpgradePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dream"
          element={
            <ProtectedRoute>
              <DreamFeaturePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;